var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4201 35.4995C33.5431 47.5145 8.25189 48.7555 2.51089 37.4175C-3.23011 26.0795 10.5252 2.10682 23.1422 1.48682C35.7602 0.813821 47.2971 23.4885 40.4201 35.4995Z",
    fill: "#FCD118"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.21 7.33855C18.632 3.94455 22.502 1.6759 26.271 1.4909C38.889 0.813899 50.4258 23.4906 43.5488 35.5036C36.6718 47.5166 11.3811 48.7596 5.64014 37.4216C5.38658 36.9181 5.17126 36.3968 4.99609 35.861",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1328 9.86963C34.8261 9.74705 34.4993 9.6825 34.1689 9.68018H3.2998C2.96948 9.68231 2.64262 9.74687 2.33594 9.86963L18.7358 21.2397L35.1328 9.86963Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4077 23.6616C19.2117 23.8026 18.9763 23.878 18.7349 23.8774C18.4908 23.877 18.2526 23.8018 18.0527 23.6616L0.829102 11.7212C0.807597 11.8763 0.795442 12.0334 0.792969 12.1899V32.0376C0.792837 32.3669 0.857394 32.6933 0.983399 32.9976C1.1094 33.3018 1.29442 33.5782 1.52734 33.811C1.76027 34.0439 2.03648 34.2281 2.34082 34.354C2.64516 34.4799 2.97144 34.5447 3.30078 34.5444H34.1709C34.5002 34.5447 34.8265 34.4799 35.1309 34.354C35.4352 34.2281 35.7114 34.0439 35.9443 33.811C36.1773 33.5782 36.3623 33.3018 36.4883 32.9976C36.6143 32.6933 36.6788 32.3669 36.6787 32.0376V12.1899C36.6768 12.0331 36.6631 11.8759 36.6377 11.7212L19.4077 23.6616Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2fbed3368a829d03575b2a1812e43cea.svg";
export { ForwardRef as ReactComponent };